export const NZ = {
    "Auckland": [
        "Auckland",
        "Manukau City",
        "Waitakere",
        "Northcote",
        "Pukekohe East",
        "Waiuku",
        "Warkworth",
        "Snells Beach",
        "Helensville",
        "Maraetai"
    ],
    "Bay of Plenty": [
        "Tauranga",
        "Rotorua",
        "Whakatane",
        "Te Puke",
        "Kawerau",
        "Mount Maunganui",
        "Katikati",
        "Waihi Beach"
    ],
    "Canterbury": [
        "Christchurch",
        "Timaru",
        "Rolleston",
        "Lincoln",
        "Prebbleton",
        "Darfield",
        "Woodend",
        "Oxford",
        "Leeston",
        "West Melton"
    ],
    "Chatham Islands": ["Waitangi"],
    "Gisborne": ["Gisborne"],
    "Hawke’s Bay": ["Napier", "Havelock North", "Clive", "Hastings"],
    "Manawatu-Wanganui": [
        "Palmerston North",
        "Feilding",
        "Levin",
        "Marton",
        "Taumaruiti",
        "Foxton",
        "Ashhurst",
        "Pahiatua"
    ],
    "Marlborough": ["Blenheim", "Renwick"],
    "Nelson": ["Nelson"],
    "Northland": [
        "Whangarei",
        "Kerikeri",
        "Kaitaia",
        "Dargaville",
        "Kaikohe",
        "Ruakaka"
    ],
    "Otago": [
        "Dunedin",
        "Mosgiel",
        "Wanaka",
        "Alexandra",
        "Cromwell",
        "Balclutha",
        "Milton"
    ],
    "Southland": ["Invercargill", "Winton", "Te Anau"],
    "Taranaki": ["New Plymouth", "Hawera", "Waitara", "Stratford"],
    "Tasman": ["Richmond", "Wakefield", "Brightwater"],
    "Waikato": [
        "Hamilton",
        "Taupo",
        "Cambridge",
        "Tokoroa",
        "Te Awamutu",
        "Matamata",
        "Thames",
        "Ngaruawahia",
        "Waihi",
        "Whitianga",
        "Tuakau",
        "Tauwhare",
        "Te Kumi",
        "Te Aroha",
        "Paeroa",
        "Whangamata",
        "Turangi",
        "Raglan",
        "Otorohanga",
        "Kihikihi",
        "Pokeno"
    ],
    "Wellington": [
        "Wellington",
        "Lower Hutt",
        "Porirua",
        "Upper Hutt",
        "Paraparaumu",
        "Waikanae",
        "Paraparaumu Beach",
        "Raumati Beach"
    ],
    "West Coast": ["Greymouth", "Westport", "Hokitika"]
}